/*
|--------------------------------------------------------------------------
| Component: CheckboxField.jsx
| Author: Sayed Ahmed
| Description: A reusable checkbox input with validation error display
|--------------------------------------------------------------------------
*/

import React from "react";
import { useTranslation } from "react-i18next";

export default function CheckboxField({
  label,
  name,
  register,
  errors,
  className = "",
  checked = undefined,         // For controlled components
  defaultChecked = undefined,  // For uncontrolled components
  disabled = false,
}) {
  const { t } = useTranslation();

  return (
    <div className="form-group form-check custom-checkbox mb-3 checkbox-danger">
      <input
        type="checkbox"
        id={name}
        {...register(name)}
        className={`form-check-input cursor-pointer ${className}`}
        disabled={disabled}
        checked={checked}
        defaultChecked={defaultChecked}
      />
      
      {/* Label next to checkbox */}
      <label htmlFor={name} className="cursor-pointer ml-1">
        {t(label)}
      </label>

      {/* Show error message if exists */}
      {errors?.[name]?.message && (
        <p className="text-red-600 text-sm">{t(errors[name]?.message)}</p>
      )}
    </div>
  );
}
